import { useEffect, useRef } from "react";

const BASE_TITLE = "CompBox";

/**
 * Sets document.title to `pageName • CompBox`.
 * Restores the pre-mount document.title on unmount.
 */
export function usePageTitle(pageName?: string) {
  const initialTitle = useRef(document.title);

  useEffect(() => {
    document.title = pageName ? `${pageName} • ${BASE_TITLE}` : BASE_TITLE;
  }, [pageName]);

  useEffect(() => {
    return () => {
      document.title = initialTitle.current;
    };
  }, []);
}
